(function () {
  if (window.LevaGeo && window.LevaGeo._initialized) return;

  var STORAGE_KEY = 'leva_geo_ip_v1';
  var TTL_MS = 30 * 24 * 60 * 60 * 1000;
  var pending = [];
  var ready = false;

  function readCache() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var o = JSON.parse(raw);
      if (!o || typeof o.t !== 'number') return null;
      if (Date.now() - o.t > TTL_MS) return null;
      return o;
    } catch (e) {
      return null;
    }
  }

  function writeCache(data) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(Object.assign({ t: Date.now() }, data)));
    } catch (e) {}
  }

  function dispatch(data) {
    window.LevaGeo.data = data;
    ready = true;

    for (var i = 0; i < pending.length; i++) {
      pending[i](data);
    }
    pending = [];

    document.dispatchEvent(new CustomEvent('leva:geo-ready', { detail: data }));
  }

  window.LevaGeo = {
    _initialized: true,
    STORAGE_KEY: STORAGE_KEY,
    TTL_MS: TTL_MS,
    data: null,
    onReady: function (cb) {
      if (ready) {
        cb(window.LevaGeo.data);
        return;
      }
      pending.push(cb);
    }
  };

  function fetchGeo() {
    var config = window.__levaGeoConfig || {};
    var url = 'https://ipapi.co/json/';

    if (config.apiKey) {
      url += '?key=' + encodeURIComponent(config.apiKey);
    }

    fetch(url)
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        if (!data || data.error) {
          dispatch({
            error: data && data.error ? data.error : 'Request failed',
            latitude: null,
            longitude: null,
            countryCode: null,
            country: null,
            city: null,
            region: null
          });
          return;
        }

        var payload = {
          latitude: data.latitude,
          longitude: data.longitude,
          countryCode: data.country_code || null,
          country: data.country_name || null,
          city: data.city || null,
          region: data.region || null
        };

        writeCache(payload);
        dispatch(payload);
      })
      .catch(function (err) {
        dispatch({
          error: err && err.message ? err.message : 'Request failed',
          latitude: null,
          longitude: null,
          countryCode: null,
          country: null,
          city: null,
          region: null
        });
      });
  }

  var cached = readCache();
  if (cached) {
    dispatch(cached);
  } else {
    fetchGeo();
  }
})();
